import React from 'react';
import { bunnyTestimonials } from '../../bunnyMock';
import { Star, Quote } from 'lucide-react';

const BunnyTestimonialSection = () => {
  return (
    <section id="testimonials" className="section-spacing bunny-section-dark">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl font-serif bunny-headline text-white mb-6">
            What Fashion Lovers Say
          </h2>
          <p className="text-xl text-gray-300 font-sans max-w-2xl mx-auto">
            Real reviews from real trendsetters
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {bunnyTestimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id} 
              className="bunny-testimonial"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Quote icon */}
              <div className="mb-4">
                <Quote className="w-10 h-10 bunny-accent-pink opacity-50" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, idx) => (
                  <Star key={idx} className="w-5 h-5 fill-pink-400 text-pink-400" />
                ))}
              </div>

              {/* Testimonial text */}
              <p className="text-base text-gray-300 font-sans leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="pt-4 border-t border-gray-700">
                <p className="font-sans font-bold text-white">{testimonial.name}</p>
                <p className="font-sans text-sm text-gray-400">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Social proof section */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-12 bg-white/10 backdrop-blur-md rounded-none border-2 border-pink-400 px-12 py-8">
            <div className="text-center">
              <p className="text-5xl font-serif bunny-headline bunny-accent-pink">15K+</p>
              <p className="text-sm font-sans text-gray-300 font-bold tracking-wider mt-2">INSTAGRAM FOLLOWERS</p>
            </div>
            <div className="hidden sm:block w-px h-12 bg-gray-600"></div>
            <div className="text-center">
              <p className="text-5xl font-serif bunny-headline bunny-accent-pink">5.0</p>
              <p className="text-sm font-sans text-gray-300 font-bold tracking-wider mt-2">AVERAGE RATING</p>
            </div>
            <div className="hidden sm:block w-px h-12 bg-gray-600"></div>
            <div className="text-center">
              <p className="text-5xl font-serif bunny-headline bunny-accent-pink">99%</p>
              <p className="text-sm font-sans text-gray-300 font-bold tracking-wider mt-2">WOULD RECOMMEND</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BunnyTestimonialSection;
